customElements.define('product-card-images', class extends HTMLElement {
    constructor() {
        super();
        this.images = Array.from(this.querySelectorAll('.spc__main-img'));
        this.dots = Array.from(this.querySelectorAll('.dot'));
        this.currentIndex = 0;
        this.intervalId = null;
        this.isMobile = window.innerWidth < 768;

        this.setupEventListeners();
        this.setupTouchEvents();
    }

    setupEventListeners() {
        if (!this.isMobile) {
            this.addEventListener('mouseenter', this.startSlider);
            this.addEventListener('mouseleave', this.stopSlider);
        }

        this.dots.forEach((dot, index) => {
            dot.addEventListener('click', () => this.goToImage(index));
        });

        window.addEventListener('resize', this.handleResize);
    }

    setupTouchEvents() {
        let startX, moveX;
        this.addEventListener('touchstart', (e) => {
            startX = e.touches[0].clientX;
        });

        this.addEventListener('touchmove', (e) => {
            moveX = e.touches[0].clientX;
        });

        this.addEventListener('touchend', () => {
            if (startX + 50 < moveX) {
                this.showPreviousImage();
            } else if (startX - 50 > moveX) {
                this.showNextImage();
            }
        });
    }

    handleResize = () => {
        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth < 768;
        if (wasMobile !== this.isMobile) {
            this.stopSlider();
            this.setupEventListeners();
        }
    }

    startSlider = () => {
        if (this.images.length <= 1 || this.isMobile) return;
        
        this.showNextImage();
        
        this.intervalId = setInterval(() => {
            this.showNextImage();
        }, 2000);
    }

    stopSlider = () => {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }

    showNextImage = () => {
        this.goToImage((this.currentIndex + 1) % this.images.length);
    }

    showPreviousImage = () => {
        this.goToImage((this.currentIndex - 1 + this.images.length) % this.images.length);
    }

    goToImage(index) {
        this.images[this.currentIndex].classList.remove('active');
        this.dots[this.currentIndex].classList.remove('active');
        this.currentIndex = index;
        this.images[this.currentIndex].classList.add('active');
        this.dots[this.currentIndex].classList.add('active');
    }
});